import React from "react";
import "./SignupPage.css";
import InfoSection from "./components/InfoSection";

import SignupFormV2 from "./components/SignupFormV2";

const LoginPage = () => {
  return (
    <div className="login-container">
      <div className="login-box">
        <InfoSection />
        <SignupFormV2 />
      </div>
    </div>
  );
};

export default LoginPage;